import type { Route } from '@/objects/Route';
import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';

export const useRouterStore = defineStore('router', () => {
    const CurrentRoute = ref<Route | null>(null);
    return {
        CurrentRoute,
        setRoute: (route: Route) => {
            CurrentRoute.value = route;
        },
    };
});

export const getRouterStoreRef = () => storeToRefs(useRouterStore());
